import { is } from 'ramda';

/**
 * Checks if input value is `Boolean`.
 *
 * @func isBoolean
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.3.0|v0.3.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotBoolean|isNotBoolean}
 * @example
 *
 * RA.isBoolean(false); //=> true
 * RA.isBoolean(true); //=> true
 * RA.isBoolean(null); //=> false
 */
var isBoolean = /*#__PURE__*/is(Boolean);

export default isBoolean;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/isBoolean.js
// module id = 356
// module chunks = 0